import { useTranslation } from 'next-i18next/pages';
import React from 'react';

import useCurrentLang from '@/hooks/apps/useCurrentLang';

import { selectPartnerGroups } from '@/data/shared/partners';

import Area from '@/components/apps/layouts/shared/Area';

import AboutPartnerRow from './AboutPartnerRow';

/**
 * ### AboutPartnersSection
 *
 * Where the work has been done, as three bands of marks carried along by
 * the page's own scroll: the customers of each solution, then the
 * collaborations behind them. Three bands rather than one grid because a
 * current customer and a past collaborator are not the same claim, and the
 * band headings say which is which.
 *
 * @returns The rendered section element
 * @see {@link PARTNER_GROUPS} The names rendered here, shared with the home wall
 */
export default function AboutPartnersSection() {
  const { t } = useTranslation('common');
  const currentLang = useCurrentLang();
  const groups = selectPartnerGroups(currentLang);

  return (
    <section
      className="overflow-hidden bg-apps-coreGray07"
      data-analytics-section="about_partners"
    >
      <div className="flex flex-col gap-12 py-24 lg:gap-16 lg:py-[clamp(120px,11.111vw,180px)]">
        <Area>
          <p className="text-[13px] font-bold uppercase leading-[140%] tracking-[0.65px] text-apps-corePrimary01 lg:text-[15px]">
            Customers &amp; Partners
          </p>
          <h2 className="mt-4 max-w-225 text-balance text-[28px] font-bold leading-[136%] tracking-[-0.56px] text-apps-coreGrayBlack sm:text-[32px] lg:mt-6 lg:text-[clamp(38px,3.333vw,52px)] lg:leading-[128%] lg:tracking-[-1.04px]">
            {t('다양한 산업 현장에서 검증되고 있습니다')}
          </h2>
        </Area>
        <div className="flex flex-col gap-10 lg:gap-12">
          {groups.map((group, index) => (
            <AboutPartnerRow key={group.id} group={group} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
}
